module.exports = __webpack_public_path__ + "static/img/mapL.570c03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/mapL.png
// module id = lkwg
// module chunks = 51